<!-- section template -->
<template>
  <div :class="$style.reservationItemSectionItemDetail">
    <ul :class="[$style.detailList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li v-if="!!orderBillingList[0]" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 訂單明細 </div>
          </div>
          <div class="col-md-9">
            <BaseList :data-list="orderBillingList" type="order" />
          </div>
        </div>
      </li>
      <li v-if="!!orderInfoList[0]" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 訂單資訊 </div>
          </div>
          <div class="col-md-9">
            <BaseList :data-list="orderInfoList" type="info" />
          </div>
        </div>
      </li>
      <li v-if="(orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]) || (orderItem.paymentMethod === 'Atm' && !!atmInfoList[0])" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 匯款資訊 </div>
          </div>
          <div class="col-md-9">
            <BaseList v-if="orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]" :data-list="vaccInfoList" type="info" />
            <BaseList v-if="orderItem.paymentMethod === 'Atm' && !!atmInfoList[0]" :data-list="atmInfoList" type="info" />
          </div>
        </div>
      </li>
      <!-- 發票 -->
      <li v-if="invoice.InvoiceNumber != null" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 發票資訊 </div>
          </div>
          <div class="col-md-9">
            <div class="invoice-detail__item">
              <p>發票日期：{{ invoice.CreateTime }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>發票號碼：{{ invoice.InvoiceNumber }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>隨機碼：{{ invoice.RandomNum }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>發票形式：{{ taxTypeMap[invoice.taxType] }}</p>
            </div>
            <div v-if="invoice.taxType === 'B2C'" class="invoice-detail__item">
              <p style="margin-bottom: 0">載具類型：{{ carrierTypeMap(invoice.CarrierType) }}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <BasePre>{{ orderItem }}</BasePre>
  </div>
</template>

<script>
import formatGender from '@utils/format-gender'
import { merchantComputed } from '@store/helpers'
import formatPrice from '@utils/format-price'
import {
  orderAtmInfoList,
  orderInfoList,
  orderIsCanPay,
  orderIsOffline,
  orderIsUseDeduct,
  orderPetInfoList,
  orderIsPrepaidUnpaidAndDeduct,
  orderVaccInfoList,
  orderBillingReservationList,
  orderReservationInfoList,
} from '@utils/ipetbooking-order'

export default {
  components: {},
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },

    invoice: {
      type: Object || null,
      default: null,
    },
  },
  data() {
    return {
      taxTypeMap: {
        B2C: '個人',
        B2B: '公司',
        DONATE: '捐贈發票',
      },
    }
  },
  computed: {
    ...merchantComputed,
    couponDiscount() {
      return this.orderItem.coupon.discountValue > this.orderItem.priceBase ? this.orderItem.priceBase : this.orderItem.coupon.discountValue
    },
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.orderItem.byOrderExtrafields || {}

      return !!Object.keys(orderExtrafields)[0]
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    isOffline() {
      return orderIsOffline({
        order: this.orderItem,
        ordertype: 'order',
        type: 'deposit',
      })
    },
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.orderItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.orderItem })
    },
    orderBillingList() {
      return orderBillingReservationList({
        type: 'memberOrder',
        ...this.orderItem,
        isUnpaidAndDeduct: this.isUnpaidAndDeduct,
      })
    },
    orderInfoList() {
      return orderInfoList({ ...this.orderItem })
    },
    reservationInfoList() {
      return orderReservationInfoList({ ...this.orderItem })
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.orderItem, unpaid: this.orderItem.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.orderItem, unpaid: this.orderItem.priceTotal })
    },
    petInfoList() {
      return orderPetInfoList({ ...this.orderItem })
    },
  },
  methods: {
    orderIsCanPay,
    formatPrice,
    carrierTypeMap(key) {
      const map = {
        0: '手機條碼',
        1: '自然人憑證條碼',
        2: 'ezPay 電子發票載具',
      }

      if (key == null) return '無（寄送電子發票至客戶 email）'
      else return map[key]
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.reservationItemSectionItemDetail {
  :global {
    .reservationItemSectionItemDetail {
      @include unstyled;
    }

    .invoice-detail__item {
      display: flex;
      justify-content: space-between;

      p {
        margin-bottom: 12px;
        color: #687580;
      }
    }
  }
}

.detailList {
  @include list-unstyled;

  margin: 0 0 2rem;

  :global {
    .detailList {
      &__item {
        &:not(:last-child) {
          padding-bottom: 2rem;
          border-bottom: 1px solid $color-line;
        }

        &:not(:first-child) {
          padding-top: 2rem;
        }

        &.isTitle {
          padding: 1.5rem;
          background: rgba($color-secondary, 0.1);
          border-bottom: unset;
        }
      }

      &__title {
        @include max-md {
          margin-bottom: 1.5rem;
          font-weight: 500;
          color: $color-blue-dark;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailList {
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}

.extrafieldList {
  margin: -0.5rem 0;
  line-height: 2;

  :global {
    .extrafieldList {
      &__item {
        padding: 0.5rem 0;

        @include max-md {
          font-size: 0.75rem;
        }
      }

      &__title {
        @include unstyled;
      }

      &__text {
        color: $color-gray-2;
      }
    }
  }
}
</style>
